import { loginRequest, msalInstance } from "../config/authConfig";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

class AuthService {
  async refreshAccessToken() {
    const account = msalInstance.getAllAccounts()[0];
    if (account.homeAccountId) {
      try {
        const resp = await msalInstance.acquireTokenSilent({
          account,
          scopes: loginRequest.scopes,
        });
        return resp?.account?.idToken;
      } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
          return msalInstance
            .acquireTokenPopup(loginRequest)
            .then((resp) => {
              return resp.accessToken;
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          await msalInstance.logoutRedirect({
            onRedirectNavigate: (url) => {
              return false;
            },
          });
        }
      }
    }
  }
}

export default new AuthService();
